// ── 연차 대량 추가 모달 (스프레드시트 붙여넣기) ───────────────────────────────
import React from 'react';
import Modal from '../../../components/Modal';
import { BULK_COLUMNS, LEAVE_TYPES_BULK, LEAVE_CATEGORIES } from './constants';
import { isBulkRowEmpty } from './utils';
import {
  outlineBtn, primaryBtn,
  guideBoxStyle, sheetWrapStyle, sheetTableStyle,
  sheetIndexHeaderStyle, sheetHeaderStyle,
  sheetIndexCellStyle, sheetCellStyle,
  sheetInputStyle, errorInputStyle,
} from './stylesB';

export function BulkModal({
  bulkOpen, closeBulkModal,
  bulkRows, bulkErrors,
  bulkNonEmptyCount, bulkInvalidRowCount, bulkSubmitting,
  addBulkRows, trimEmptyBulkRows,
  handleBulkCellChange, handleBulkCellPaste,
  submitBulk,
}) {
  return (
    <Modal
      open={bulkOpen}
      title="연차 대량 추가 (스프레드시트 붙여넣기)"
      icon="📋"
      onClose={closeBulkModal}
      width="min(980px, 96vw)"
      footer={(
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ color: bulkInvalidRowCount > 0 ? '#dc2626' : 'var(--text-muted)', fontWeight: 700 }}>
            입력행 {bulkNonEmptyCount} / 오류행 {bulkInvalidRowCount}
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={outlineBtn} onClick={closeBulkModal}>닫기</button>
            <button
              style={primaryBtn}
              disabled={bulkSubmitting || bulkNonEmptyCount === 0 || bulkInvalidRowCount > 0}
              onClick={submitBulk}
            >
              {bulkSubmitting ? '추가 중...' : '대량 추가 실행'}
            </button>
          </div>
        </div>
      )}
    >
      <div style={{ display: 'grid', gap: 12 }}>
        <div style={guideBoxStyle}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>붙여넣기 가이드</div>
          <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>구글 스프레드시트에서 범위를 복사한 뒤 아래 셀에 붙여넣으세요.</div>
          <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>빨간색 셀은 형식 오류이며 직접 수정할 수 있습니다.</div>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button style={outlineBtn} onClick={() => addBulkRows(10)}>행 10개 추가</button>
          <button style={outlineBtn} onClick={trimEmptyBulkRows}>빈 행 정리</button>
        </div>
        <div style={sheetWrapStyle}>
          <table style={sheetTableStyle}>
            <thead>
              <tr>
                <th style={sheetIndexHeaderStyle}>#</th>
                {BULK_COLUMNS.map((col) => (
                  <th key={col.key} style={sheetHeaderStyle}>
                    {col.label}{col.required ? ' *' : ''}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {bulkRows.map((row, rowIndex) => (
                <tr key={`br-${rowIndex}`}>
                  <td style={sheetIndexCellStyle}>{rowIndex + 1}</td>
                  {BULK_COLUMNS.map((col, colIndex) => {
                    const error = bulkErrors[rowIndex][col.key];
                    const shouldShowError = !isBulkRowEmpty(row) && Boolean(error);
                    return (
                      <td key={`${rowIndex}-${col.key}`} style={sheetCellStyle}>
                        <input
                          list={col.key === 'type' ? 'leave-types' : col.key === 'category' ? 'leave-categories' : undefined}
                          style={shouldShowError ? errorInputStyle : sheetInputStyle}
                          title={shouldShowError ? error : ''}
                          value={row[col.key]}
                          placeholder={col.placeholder}
                          onChange={(e) => handleBulkCellChange(rowIndex, col.key, e.target.value)}
                          onPaste={(e) => handleBulkCellPaste(e, rowIndex, colIndex)}
                        />
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* 자동완성 datalist */}
        <datalist id="leave-types">
          {LEAVE_TYPES_BULK.map((type) => <option key={type} value={type} />)}
        </datalist>
        <datalist id="leave-categories">
          {LEAVE_CATEGORIES.map((cat) => <option key={cat} value={cat} />)}
        </datalist>
      </div>
    </Modal>
  );
}
